import { doApi } from 'services/api';

// deletes current logged in User from Cognito (used for testing)
export const deleteUser = async (emailOrPhone) => {
  return await doApi({route:'admin/deleteuser?username=' + encodeURIComponent(emailOrPhone)});
};

export const printReceipt = async (revenueId) => {
  return await doApi({route:'admin/printreceipt/' + revenueId});
};

export const getReadOnlyAdmins = async () => {
  return await doApi({route: 'getreadonlyadmins'});
};

export const addReadOnlyAdmin = async (username, firstName, lastName, crmId) => {
  return await doApi({
    route: 'admin/addreadonlyadmin',
    method: 'POST',
    data: {username, firstName, lastName, crmId},
  });
};

export const removeReadOnlyAdmin = async username => {
  return await doApi({route: `admin/removereadonlyadmin?username=${encodeURIComponent(username)}`, method: 'POST'});
};

export const getDownloads = async (reportType, queryType, data) => {
  if (data.searchDateFrom || data.searchDateTo) {
    // return console.log({route:'admin/querydownloads?reporttype=' + reportType + '&querytype=' + queryType
    //                      + '&queryvalue1=' + encodeURIComponent(data.searchDateFrom || '')
    //                      + '&queryvalue2=' + encodeURIComponent(data.searchDateTo || '') });
    return await doApi({route:'admin/querydownloads?reporttype=' + reportType + '&querytype=' + queryType
                         + '&queryvalue1=' + encodeURIComponent(data.searchDateFrom || '')
                         + '&queryvalue2=' + encodeURIComponent(data.searchDateTo || '') });
  }
  else {
    // return console.log({route:'admin/querydownloads?reporttype=' + reportType + '&querytype=' + queryType + '&queryvalue1=' + encodeURIComponent(data.searchValue || '')});
    return await doApi({route:'admin/querydownloads?reporttype=' + reportType + '&querytype=' + queryType + '&queryvalue1=' + encodeURIComponent(data.searchValue || '')});
  }
};

export const getDocuments = async (documentType, queryType, data) => {
  return await doApi({route:'admin/querydocuments?documenttype=' + documentType + '&querytype=' + queryType + '&queryvalue=' + encodeURIComponent(data.searchValue || '')});
};

const adminGetDocumentPreSignedUrl = async (doc) => {
  const reportType = (['User', 'Dept', 'Fund'].indexOf(doc.ReportType) > -1) ? "ACR" : doc.ReportType;
  const fileParams = doc.FileName
    ? `?fn=${encodeURIComponent(doc.FileName)}`
    : `?filenames=${encodeURIComponent(doc.FileNames)}&prettyfilename=${encodeURIComponent(doc.PrettyFileName)}`;
  return await doApi({route: `admin/documenturl/${reportType}/${doc.ReportYear}${fileParams}`});
};

export const adminGetPreSignedUrlForUpload = async (doc) => {
  return await doApi({route: `admin/uploaddocumenturl?filename=${doc.fileName}&reporttype=${doc.reportType}&contenttype=${doc.contentType}`});
};

export const adminProcessReportFiles = async (docType, reportYear) => {
  return await doApi({route: `admin/processreportfiles?documenttype=${docType}&reportyear=${reportYear}`});
};

export const adminDownloadDocument = async (doc) => {

  const url = await adminGetDocumentPreSignedUrl(doc);

  if (!url || !url.presignedUrl)
    return {error: 'Unable to access document'}

  console.log(url.presignedUrl)

  const a = document.createElement('a');
  a.href = url.presignedUrl;
  a.download = doc.PrettyFileName;
  document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
  a.click();
  a.remove();
};

export const deleteDocument = async (doc) => {
  return await doApi({ route: `admin/deletedocument/${doc.ReportType}/${doc.ReportYear}?filename=${encodeURIComponent(doc.FileName)}` });
};

export const saveDocument = async (doc) => {
  return await doApi({ route: `admin/savedocument`, method:"POST", data: doc });
};

export const uploadBrochure = async (file, reportType, reportYear) => {
  const contentType = file.type || 'application/pdf';
  const uploadUrlResponse = await doApi({
    route: `admin/uploadbrochureurl?filename=${encodeURIComponent(file.name)}&contenttype=${encodeURIComponent(contentType)}&reporttype=${encodeURIComponent(reportType)}&reportyear=${encodeURIComponent(reportYear)}`,
  });

  if (!uploadUrlResponse || !uploadUrlResponse.presignedUrl)
    return {error: uploadUrlResponse?.error || 'Unable to create the brochure upload URL.'};

  const uploadResponse = await fetch(uploadUrlResponse.presignedUrl, {
    method: 'PUT',
    headers: {'Content-Type': contentType},
    body: file,
  });

  if (!uploadResponse.ok)
    return {error: `The brochure upload failed with status ${uploadResponse.status}.`};

  return await saveDocument({
    DocumentType: 'BROCHURE',
    ReportType: reportType,
    ReportYear: String(reportYear),
    FileName: file.name,
  });
};

export const uploadEiarSpreadsheet = async (year, reports) => {
  return await doApi({ route: `admin/uploadeiarspreadsheet`, method:"POST", data: {year, reports} });
};

export const getNewEiarStatus = async reportYear => {
  return await doApi({route: `admin/neweiarstatus?reportyear=${reportYear}`});
};

export const checkNewEiarFiles = async reportYear => {
  return await doApi({route: `admin/checkneweiarfiles?reportyear=${reportYear}`});
};

export const publishNewEiar = async reportYear => {
  return await doApi({route: 'admin/publishneweiar', method: 'POST', data: {reportYear}});
};

export const deleteNewEiarFile = async (reportYear, fileName) => {
  return await doApi({
    route: 'admin/deleteneweiarfile',
    method: 'POST',
    data: {reportYear, fileName},
  });
};
